import React from "react";
import { Controller } from "react-hook-form";

import Input from "@/components/Atoms/Inputs/Input";
import ErrorUI from "@/components/Atoms/ErrorUI";

import { InputGroup, InputWrapper } from "../style";

const NameInput = ({
  name,
  control,
  showLabels,
  namePlaceholder,
  inputFontSize,
  inputLineHeight,
}) => (
  <InputWrapper>
    <InputGroup hasBottomBorder showLabels={showLabels}>
      <Controller
        name={name}
        control={control}
        shouldUnregister
        render={({
          field: { value, onBlur, onChange, ref },
          fieldState: { error },
        }) => (
          <>
            <Input
              ref={ref}
              type="text"
              placeholder={namePlaceholder}
              name={name}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              icon="icon-user-face-2"
              iconDimension="16px"
              variant="v2"
              inputFontSize={inputFontSize}
              inputLineHeight={inputLineHeight}
            />
            {error && <ErrorUI hasBottomBorder error={error?.message} />}
          </>
        )}
      />
    </InputGroup>
  </InputWrapper>
);

export default NameInput;
